import { targetSetupFiltersStore } from "../stores/target-setup-filters.store";
import { resolveOrgIdsExact } from "../domains/resolveOrgIdsExact";
import { targetSetupOverviewStore } from "../stores/target-setup-overview.store";

export const loadTargetSetupOverview = async () => {
  const { years, frameworks, categories, orgIds } =
    targetSetupFiltersStore.filters;
  await targetSetupOverviewStore.load({
    years,
    frameworks,
    categories,
    // Scoped to exactly the picked org(s), not their descendants — picking
    // a business-unit node means "does THIS node have a target", not "does
    // any org anywhere underneath it have one." Mirrors resolveOrgIdsExact's
    // use elsewhere on this page (org breakdown, Excel export).
    orgIds: resolveOrgIdsExact(
      orgIds,
      targetSetupFiltersStore.available.orgTree,
    ),
  });
};
